import React from 'react';
import { Typography, Button } from '@material-ui/core';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <Typography variant="h6" color="error">
            Ocurrió un error en la vista.
          </Typography>
          <Button variant="contained" color="primary" onClick={() => window.location.reload()} style={{ marginTop: 10 }}>
            Recargar Página
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
